import React from "react";
import { Link } from "react-router-dom";

import LinkedInIcon from "@material-ui/icons/LinkedIn";
import InstagramIcon from "@material-ui/icons/Instagram";
import GitHubIcon from "@material-ui/icons/GitHub";

import "./style.css";

function Footer() {
  return (
    <div className="footer">
      <div className="footer__body">
        <div className="footer__left">
          <h4>Surya Mahla</h4>
          <div className="footer__left__icon__container">
            <a
              href="https://www.linkedin.com/in/surya-mahla-1ab702189/"
              target="_blank"
            >
              <LinkedInIcon className="footer__left__icon" />
            </a>
            <a href="https://www.instagram.com/lamndjj/" target="_blank">
              <InstagramIcon className="footer__left__icon" />
            </a>
            <a href="https://github.com/lamndj" target="_blank">
              <GitHubIcon className="footer__left__icon" />
            </a>
          </div>
        </div>
        <div className="footer__right">
          <Link to="/contact">
            <button>Start a project</button>
          </Link>
        </div>
      </div>
      <div className="footer__bottom__contact">
        <a href="tel:+919717139010">+91-9717139010</a>|
        <a href="mailto:mahlsurya@gmail.com">mahlasurya@gmail.com</a>
      </div>
    </div>
  );
}

export default Footer;
